import { Button, Typography } from '@mui/material';

import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

import { ActionBar } from '../../../Layout';

import { ConfirmQuestionsContainer } from './components.styled';

type ConfirmQuestionProps = {
  question: string;
  description: string;
  onYes: () => void;
  onNo: () => void;
};

export function ConfirmQuestion({
  question,
  description,
  onYes,
  onNo,
}: ConfirmQuestionProps) {
  const { t } = useTranslate();
  return (
    <ConfirmQuestionsContainer>
      <Typography variant="h3" mb={3} textAlign="center">
        {question}
      </Typography>
      <Typography variant="body2" textAlign="center">
        {description}
      </Typography>
      <ActionBar mt={3}>
        <Button
          {...getDataTestId(`confirm-question-yes-button`)}
          variant="outlined"
          fullWidth
          onClick={onYes}
        >
          {t('moreInfo.confirmQuestion.button.yes')}
        </Button>
        <Button
          {...getDataTestId(`confirm-question-no-button`)}
          variant="outlined"
          fullWidth
          onClick={onNo}
        >
          {t('moreInfo.confirmQuestion.button.no')}
        </Button>
      </ActionBar>
    </ConfirmQuestionsContainer>
  );
}
